import Rating from '~/js/components/global/reviews/Rating';

const { Component, Fragment } = React;

class ShortReview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reviewCount: null, 
    };

    this.abortOverviewController = new window.AbortController();
    this.abortReviewsController = new window.AbortController();
    this.enableModalRef = React.createRef();
  }

  componentDidMount() {
    this.mounted = true;
    const { review, urlReviews } = this.props;

    if(this.mounted) {
      if(urlReviews.showReviews && urlReviews.resort === review.resortCode) {
        this._handleUrlReviews();
      }
    }

    const fetchOverview = (rstCode) => {
      fetch(`/fetchOverview/?resortCode=${rstCode}`, { signal: this.abortOverviewController.signal })
        .then((response) => response.json())
        .then((json) => {
          if(this.mounted) {
            this.setState({
              reviewCount: json.data.resortOverview.reviewCount,
              loadingOverview: false
            });
          }
        })
        .catch((error) => {
          if(error.name === 'AbortError') {return;}
          throw error;
        });
    };

    fetchOverview(review.resortCode);
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.abortOverviewController.abort();
    this.abortReviewsController.abort();
  }

  _handleUrlReviews = () => {
    const { review, enableUrlModal } = this.props;

    this.timeoutId = setTimeout(() => {
      enableUrlModal(review);
    }, 700);
  }

  render() {
    const isDesktop = window.innerWidth > 768;
    const { currentSlide, index, enableModal, review } = this.props;
    const { resortName, resortCountry, resortCity, body, postage, rating, reviewSite } = review;
    const shortenString = (input, maxlength) => input.length > maxlength ? <Fragment>{input.substring(0, maxlength)}<span>...</span></Fragment> : input;
    const shortBody = body ? shortenString(body, isDesktop ? 208 : 190) : '';
    const resortUrls = {
      "BTC": "/resorts/turks-caicos/",
      "BNG": "/resorts/negril/",
      "BBO": "/resorts/ocho-rios/"
    };

    return (

      <Fragment>
        <div className="review guest-reviews__review">
          <h4 className="review__heading">
            <a href={resortUrls[review.resortCode]}>{resortName}
            <span>{resortCity}, {resortCountry.replace(' ISLANDS', '')}</span></a>
          </h4>

          <div className="review__rating">
          <a href={resortUrls[review.resortCode]}>
            <Rating rating={rating} showRating /></a>
          </div>

          <div className="number-reviews">
            <p>{this.state.reviewCount} Verified Reviews</p>
          </div>

          <div className="review__content">
            <p className="review__paragraph">
              <i className="icon-avatar review__icon" />
              {shortBody}

              <button ref={this.enableModalRef} tabIndex={currentSlide === index ? 0 : -1} onClick={() => enableModal(review)} className="review__button">{`${review.body.length > 208 ? 'Read More' : 'More Reviews'}`}</button>
            </p>

            <div className="review__timestamp">
              <span className="review__date">{postage} on </span>
              <img className="review__img" src={`https://cdn.sandals.com/sandals/v12/images/general/all-inclusive/home-v2/${reviewSite.toLowerCase()}-icon.svg`} />
              <span className="review__website">{reviewSite}</span>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ShortReview;